import { graphqlFindResults } from '../../graphql-helpers';
import React, {useCallback} from 'react';
import {useEffect, useState} from "react";
import {GraphQlSelect, GraphQlSelectProps} from "./GraphQlSelect";
import { ApolloQueryResult } from '@apollo/client';

type GraphqlSelectIdProps<Type extends { id: any}> = Omit<GraphQlSelectProps<Type>,'value'> & {
    value:string|number|string[]|number[],
    valueQuery?: ApolloQueryResult<Type>
};

/***
 * 
 * Select widget that uses :id as value rather than the full object
 * very, very fiddly
 * 
 * valueQuery allows for a query to fetch the selected value  (only required when the value will not be fetched by the basic query)
 * 
 */


export function GraphQlSelectId<Type extends { id: any}>(props:GraphqlSelectIdProps<Type>) {
    // convert values here before passing to the select...
    const [selectedFull,setSelectedFull] = useState<Type|Type[]|null>([]);

    useEffect(()=>{
        if(props.multiple) {
            // compare array contents - don't trigger refresh if identical
            if(Array.isArray(selectedFull) && Array.isArray(props.value)) {
                if(props.value.length === selectedFull.length && (props.value as any[]).every((v, i) => v === (selectedFull as any[])[i].id)) {
                    return;
                }
            }
        }
        let newValue:Type[]|Type|null = [];
        // we want to look for possible data in 
        // - valueQuery (pulled for the selected IDs)
        // - selectedFull (the current set of data shown on screen)
        // - queryResult
        let options = graphqlFindResults(props.valueQuery)??[];
        if(props.queryResult?.data) {
            options = options.concat(graphqlFindResults(props.queryResult.data));
        }
        if(props.filterOptions) {
            options = props.filterOptions(options);
        }
        // note that selectedFull will be pre-filtered, so skip that for these records!!
        if(!props.valueQuery) {
            options = options.concat(selectedFull);
        }
        if(props.value||props.value===0||props.value==='0') {
            if(props.multiple) {
                (props.value as Array<number|string>).forEach((valueEntry)=>{
                    const found = options.find((option)=>option.id==valueEntry);
                    if(found) { (newValue as Array<Type>).push(found); }
                });
            } else {
                const found = options.find((option)=>option.id==props.value);
                if(found) { newValue = found; }
            }
        } else {
            newValue = selectedFull;
        }

        setSelectedFull(newValue);
    },[props.valueQuery?.data,props.value,props.queryResult?.data]);
    const onChange = useCallback((evt) => {
        let value = null;
        if(props.multiple) {
            value = evt.target.value.map((v)=>v?.id);
        } else {
            value = evt.target.value?.id;
        }
        console.log('CHANGE',evt);
        props.onChange({target:{name:evt.target.name,value:value}});
    },[props.onChange]);
    return <GraphQlSelect<Type> {...props} value={selectedFull} onChange={onChange}/>;
}